import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import { ChatLeft, Cursor, HandThumbsUp } from 'react-bootstrap-icons'
import { formatNumber } from '../../../../../utils/Helper'

export default observer(function TotalInteractions({ currentAuthentication }) {

  const histories = useMemo(() => currentAuthentication.authentication_histories, [currentAuthentication.authentication_histories, currentAuthentication.authentication_histories.length])

  const likes = useMemo(() => {
    if(!histories.length) return 0
    return histories[histories.length - 1].average_likes
  }, [histories, histories.length])

  const comments = useMemo(() => {
    if(!histories.length) return 0
    return histories[histories.length - 1].average_comments
  }, [histories, histories.length])

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode rounded-lg col-span-2">
      <div className="flex justify-between p-8 border-b-1 border-gray-300 dark:border-rb-dark-mode-lighter">
        <div className="flex items-center">
          <div className="mr-2 dark:text-white"><Cursor /></div>
          <p className="font-bold text-xl dark:text-white">Total Interactions</p>
        </div>
      </div>
      <div className="flex justify-between p-8 border-b-1 border-gray-300 dark:border-rb-dark-mode-lighter">
        <div className="flex items-center">
          <div className="mr-2 dark:text-white"><HandThumbsUp /></div>
          <p className="font-bold text-xl dark:text-white">Average Likes</p>
        </div>
        <p className="font-bold dark:text-white">{formatNumber(+likes)}</p>
      </div>
      <div className="flex justify-between p-8 border-b-1 border-gray-300 dark:border-rb-dark-mode-lighter">
        <div className="flex items-center">
          <div className="mr-2 dark:text-white"><ChatLeft /></div>
          <p className="font-bold text-xl dark:text-white">Average Comments</p>
        </div>
        <p className="font-bold dark:text-white">{formatNumber(+comments)}</p>
      </div>

    </div>
  )
})